<template>
  <zen-one 
  :showuserinfo="false" 
  title="Pentadbiran"
  :crumbs="crumbs"
  >
  <z-page
  title="Tadbir Al Man"
  >

  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    width="80%"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      <template v-if="form.id">
        Kemaskini Al Man
      </template>
      <template v-else>
        Tambah Al Man
      </template>
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="submit"
      @success="success"
    >
      <w-transition-bounce>
          <w-alert
            class="my0 mb2 text-light"
            v-if="$page.props.flash.error"
            error
            transition="bounce"
            plain
            round
            no-border
            dismiss
            >
              {{$page.props.flash.error}}
          </w-alert>
        </w-transition-bounce>
    <!-- <z-input label="Name" v-model="form.name" name="name" :validators="[validators.required]" /> -->
    <!-- <z-input class="mt3" label="Email" v-model="form.email" name="email" :validators="[validators.required]" /> -->
      <div class="spacer"></div>
      <w-flex wrap :gap="2">
        <div class="grow mb4" style="min-width: 200px">
          <w-input
            outline
            label="No. Kad Pengenalan *"
            class="mt3"
            type="text"
            placeholder="No. Kad Pengenalan"
            name="no_id"
            v-model="form.no_id"
            :validators="[validators.required]"
          />
          <div class="spacer"></div>
          <br>
          <w-input
                outline
                label="Emel *"
                class="mt3"
                type="email"
                placeholder="Sila Masukkan Emel"
                name="email"
                v-model="form.email"
                :validators="[validators.required, validators.email]"
          />
        </div>
        <div class="grow mb4" style="min-width: 200px">
          <w-input
            outline
            label="Nama Penuh *"
            class="mt3"
            type="text"
            placeholder="Nama Penuh"
            name="name"
            v-model="form.name"
            :validators="[validators.required]"
          />
          <div class="spacer"></div>
          <br>
          <w-input
              outline
              label="Nombor Telefon *"
              class="mt3"
              type="tel"
              placeholder="Sila Masukkan Nombor Telefon"
              name="no_tel"
              v-model="form.no_tel"
              :validators="[validators.required, validators.numeric]"
          />
        </div>
      </w-flex>
      <div class="spacer"></div>
      <w-textarea 
          outline 
          label="Alamat*"
          placeholder="Sila Masukkan Alamat"
          class="mt3"
          name="alamat"
          v-model="form.alamat"
          type="text-area"
          :validators="[validators.required]"/>
      <div class="spacer"></div>
      <br>
      <w-select 
          outline
          :items="negeri" 
          label="Negeri *"  
          v-model="form.lkp_negeri_id"
          @input="getBandar(2)"
          :validators="[validators.required]"/>
      <div class="spacer"></div>
      <br>
      <w-select 
          outline
          :items="bandar" 
          label="Bandar *"  
          v-model="form.lkp_bandar_id"
          @input="getPoskod(2)"
          :validators="[validators.required]"/>
      <div class="spacer"></div>
      <br>
      <w-select 
          outline
          :items="poskod" 
          label="Poskod"  
          v-model="form.lkp_poskod_id"
          />
      <br>
      <template v-if="form.status == 1">
        <w-switch v-model="form.status" label="Aktif" v-if="form.status == 1"/>
      </template>
      <template v-else>
        <w-switch v-model="form.status" label="Tidak Aktif" />
      </template>
      <div class="spacer"></div>
      <br>
      <w-tooltip right align-bottom color="white" bg-color="blue">
          <template #activator="{ on }">
              <span v-on="on">
                <div class="spacer"></div>
                <w-input
                  outline
                  label="Sila Masukkan Kata Laluan (Kosongkan untuk tidak mengubah password) *"
                  class="mt3"
                  placeholder="Sila Masukkan Kata Laluan"
                  :type="isPassword ? 'password' : 'text'"
                  :inner-icon-right="
                    isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'
                  "
                  @click:inner-icon-right="isPassword = !isPassword"
                  name="password"
                  v-model="form.password"
                />
              </span>
          </template>
        Medan Ini Wajib , minimum 8 aksara
      </w-tooltip>

    </w-form>

    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">Tutup</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        Simpan
      </w-button>
    </template>

    
  </w-dialog>
  
  <z-table
    ref="tbluser"
    title="Senarai Al Man"
    :headers="table.headers"
    :items="table.items"
    :meta="table.meta"
    class=""
  >
    <template #button>
        <w-button dark class="indigo-dark2--bg ml1" @click="tambah()">
            <w-icon class="mr1">fal fa-plus</w-icon> Tambah
        </w-button>
    </template>
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>
      
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="fs-2 pr3 bs" bg-color="primary-dark1" tile @click="edit1(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini
        </w-button>
        <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
        </w-button>
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      isPassword: true,
      isPassword1: true,
      resourceurl: 'administration.al_man',
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Utama', route: '/' },
        { label: 'Pentadbiran', route: '/admin/user' },
        { label: 'Al Man', route: '/admin/user' }
      ],
      form: {
        id: 0,
        name: '',
        email: '',
        password_confirmation: '',
        password: '',
        role_id: 2,
      },
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          item: {name: '', email: '', mobile: ''}
        },
      poskod : [],
      bandar : [],
      negeri : [],
    }
  },
  methods: {
      getNegeri(){
          this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
            this.negeri = res
          })
      },

      getBandar(item){
            if (item == 2) {
              this.form.lkp_poskod_id = '';
              this.form.lkp_bandar_id = '';
            }
            if(item == 2 || (item == 1 && this.form.lkp_bandar_id != '')){
              this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form.lkp_negeri_id, {}).then(res => {
              this.bandar = res
              })
            }
      },

      getPoskod(item){
          if (item == 2 || this.form.lkp_bandar_id == '') {
            this.form.lkp_poskod_id = '';
          }
          if(item == 2 || (item == 1 && this.form.lkp_bandar_id != '')){
            this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form.lkp_bandar_id, {}).then(res => {
              this.poskod = res
            })
          }
      },
      tambah() {
          this.form= {
                id: 0,
                name: null,
                email: null,
                // status: null,
                password: "",
                lkp_negeri_id: "",
                lkp_bandar_id: "",
                lkp_poskod_id: "",
            };
          this.dialog.show = true
          this.getNegeri();
          // $('#' + this.resourceurl).modal('show')
          this.form.saveButton = "Simpan"
      },
      edit1(idx) {
          this.form = idx;
          this.form.saveButton = "Kemaskini";
          this.getNegeri();
          this.getBandar(1);
          this.getPoskod(1);
          this.dialog.show = true
      },
      submit() {
          // if (this.$refs.form.validate()) {
              this.dialog.loading = true
              if (this.form.id > 0) {
                  this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                      .then(res => {
                        console.log(res);
                          //update displayed record
                          this.dialog.show = false;
                          this.$inertia.reload();
                      })
                      .catch(err => {
                        if (err.response.data.errors.email == "The email has already been taken.")
                            {
                                this.email_wujud = "Emel sudah wujud";
                            }
                        if (err.response.data.errors.no_id == "The no id has already been taken.")
                            {
                                this.no_id_wujud = "No id sudah wujud";
                            }

                      })
                      .finally(() => {
                          this.dialog.loading = false
                          this.dialog.show = false
                          this.$inertia.reload();
                      });
                      this.dialog.loading = false;
              }else {
                  this.$zcomm.add(this.resourceurl + '.store', this.form)
                      .then(res => {
                      this.dialog.loading = false;
                          this.dialog.show = false;
                          this.$inertia.reload();
                      
                      })
                      .catch(err => {

                      })
                      .finally(() => {
                          this.dialog.loading = false;
                      });
                      this.dialog.loading = false;
              }
              this.dialog.loading = false;
          // }else{

          // }
      },
      destroy(idx) {
          this.form.id = idx.id
          if (confirm('Adakah anda pasti untuk memadam rekod ini?')) {
              this.$zcomm.delete(this.resourceurl + '.destroy', this.form.id)
                  .then(res => {
                    //update displayed record
                    this.sending = false;
                    this.dialog.show = false;
                    this.$inertia.visit(this.$page.url);
                    this.removeitem(res) // remove the data from list. no need to refresh page
                    if (typeof this.onAfterDelete === "function") {
                      this.onAfterDelete()
                    }
                  })
                  .finally(() => {
                    // $('#' + this.resourceurl).modal('hide')
                  });
          }
      },
    
  },
  watch: {

  },
  mounted() {
          // this.getNegeri();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
